<template lang="html">

  <section class="wrapper-view row-start ais" :showMenu="showMenu">

    <menu-lateral :show="showMenu"></menu-lateral>

    <div class="main-container">
      
      <menu-superior></menu-superior>

      <main class="wrapper-content" :style="styles.bgbody">

        <dashboard-home v-if="$route.path == '/'"></dashboard-home>
        
        <router-view v-if="$route.path != '/'"></router-view>

      </main>

    </div>

  </section>

</template>

<script lang="js">

  import menuLateral from '@/components/parts/menu-lateral'
  import menuSuperior from '@/components/parts/menu-superior'
  import dashboardHome from '@/components/views/dashboard-home'

  import {mapActions, mapGetters} from 'vuex';

  export default  {
    name: 'home',
    components :{
      'menu-lateral' : menuLateral,
      'menu-superior' : menuSuperior,
      'dashboard-home' : dashboardHome,
    },
    computed:{
      ...mapGetters({
        showMenu : 'getShowMenu',
        styles : 'getStyles'
      })
    }
  }
</script>

<style scoped>
  .wrapper {

  }
</style>



// WEBPACK FOOTER //
// src/components/views/home.vue